/* Links that open a ready-to-send e-mail in the director's own mailbox. */

export type ManualEmail = { to: string[]; cc: string[]; subject: string; body: string };

function query(params: [string, string][]): string {
  return params
    .filter(([, value]) => value)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
}

/** Gmail's compose window in the browser, signed in as `account` when several are open. */
export function gmailComposeUrl(message: ManualEmail, account?: string): string {
  return `https://mail.google.com/mail/?${query([
    ["authuser", account ?? ""],
    ["view", "cm"],
    ["fs", "1"],
    ["to", message.to.join(",")],
    ["cc", message.cc.join(",")],
    ["su", message.subject],
    ["body", message.body],
  ])}`;
}

/** The device's mail app (the Gmail app on Android, Outlook or Mail on Windows). */
export function mailtoUrl(message: ManualEmail): string {
  const recipients = message.to
    .map((address) => encodeURIComponent(address).replace(/%40/g, "@"))
    .join(",");
  const rest = query([
    ["cc", message.cc.join(",")],
    ["subject", message.subject],
    // RFC 6068 line breaks are CRLF.
    ["body", message.body.replace(/\r?\n/g, "\r\n")],
  ]);
  return `mailto:${recipients}${rest ? `?${rest}` : ""}`;
}
